import ABCyaLib from '@abcya/abcya_lib';

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    intro: {
      touchSize: 24,
      steerSize: 24,
      touchX: 0,
      steerX: 0,
    },

    title: {
      titleX: 0,
      title1X: 175,
      title2X: 20,
      title3X: 230,
    },

    results: {
      resultsX: 450,
      coinX: 20,
      titleSize: 40,
    },

    select: {
      titleX: 40,
      titleSize: 36,
      titleSize: 36,
      difficultyScale: 1,
    },

    bannerSize: 55
  };
  switch (variantId) {
    // switch on your variant IDs here and set the needed config values
  }
  switch (locale) {
    case ABCyaLib.Environment.LOCALES.esUS:
      config.intro.touchSize = 20;
      config.intro.steerSize = 20;
      config.intro.touchX = 0;
      config.intro.steerX = 0;
      config.title.titleX = -50;
      config.title.title1X = 265;
      config.title.title2X = 0;
      config.title.title3X = 250;
      config.results.resultsX = 380;
      config.results.coinX = 60;
      config.results.titleSize = 38;
      config.select.titleX = 63;
      config.select.titleSize = 24;
      config.bannerSize = 50;
      config.select.difficultyScale = 1.5;
      break;
  }

  return config;
}